export default __webpack_public_path__ + "static/media/honeycomb.c1b027b0.svg";